import {BaseEntity} from '../../../../shared/models/ApiModels'
import {initialReservation, IReservationModel} from '../../reservation/ReservationModel'
import {IBranchModel, initialBranch} from '../branch/BranchModel'
import {initialVehicleGroup, IVehicleGroupModel} from '../vehicle-group/VehicleGroupModel'
import * as Yup from 'yup'

export interface IStopSellModel extends BaseEntity {
  reservationSource: IReservationModel
  startDate: string
  vehicleGroups: IVehicleGroupModel
  endDate: string
  branches: IBranchModel
  minimumDays: number
}

export const initialStopSell: IStopSellModel = {
  reservationSource: initialReservation,
  startDate: '',
  vehicleGroups: initialVehicleGroup,
  endDate: '',
  branches: initialBranch,
  minimumDays: 0,
}

export const validationStopSell = Yup.object().shape({
  reservationSource: Yup.string().required('Rezervasyon kaynağı zorunludur'),
  startDate: Yup.string().required('Başlangıç tarihi zorunludur'),
  vehicleGroups: Yup.string().required('Araç grubu zorunludur'),
  endDate: Yup.string().required('Bitiş tarihi zorunludur'),
  branches: Yup.string().required('Şube zorunludur'),
  minimumDays: Yup.number().min(0, 'Minimum 0 olmalı').required('Minimum gün zorunludur'),
})
